var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
var MultiskillLocationsContext = createContext(null);
export var useMultiskillLocations = function () {
  return useContext(MultiskillLocationsContext);
};
var buildGroupedLocations = function (locations) {
  var _a, _b, _c, _d, _e;
  var result = {};
  var sorted = __spreadArray([], locations, true).sort(function (a, b) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var typeCompare = ((_b = (_a = a.planLocation) === null || _a === void 0 ? void 0 : _a.locationType) !== null && _b !== void 0 ? _b : '').localeCompare((_d = (_c = b.planLocation) === null || _c === void 0 ? void 0 : _c.locationType) !== null && _d !== void 0 ? _d : '');
    if (typeCompare) return typeCompare;
    var countryCompare = ((_f = (_e = a.planLocation) === null || _e === void 0 ? void 0 : _e.country) !== null && _f !== void 0 ? _f : '').localeCompare((_h = (_g = b.planLocation) === null || _g === void 0 ? void 0 : _g.country) !== null && _h !== void 0 ? _h : '');
    if (countryCompare) return countryCompare;
    return ((_k = (_j = a.planLocation) === null || _j === void 0 ? void 0 : _j.locationName) !== null && _k !== void 0 ? _k : '').localeCompare((_m = (_l = b.planLocation) === null || _l === void 0 ? void 0 : _l.locationName) !== null && _m !== void 0 ? _m : '');
  });
  for (var _i = 0, sorted_1 = sorted; _i < sorted_1.length; _i++) {
    var location_1 = sorted_1[_i];
    var type = (_b = (_a = location_1.planLocation) === null || _a === void 0 ? void 0 : _a.locationType) !== null && _b !== void 0 ? _b : '';
    var country = (_d = (_c = location_1.planLocation) === null || _c === void 0 ? void 0 : _c.country) !== null && _d !== void 0 ? _d : '';
    (_e = result[type]) !== null && _e !== void 0 ? _e : result[type] = {};
    if (!result[type][country]) {
      result[type][country] = [];
    }
    result[type][country].push(location_1);
  }
  return result;
};
export var MultiskillLocationsProvider = function (_a) {
  var locations = _a.locations,
    learningCurve100 = _a.learningCurve100,
    children = _a.children;
  // Parent (multiskill) queues do not own editable location inputs. Locations
  // passed here are the group form's (empty for the parent); never fall back to
  // the wizard queue context, which could leak member or stale parent locations
  // into the parent group form.
  var value = useMemo(function () {
    return {
      locations: locations,
      groupedLocations: buildGroupedLocations(locations),
      locIndexMap: new Map(locations.map(function (location, index) {
        return [location.id, index];
      })),
      learningCurve100: learningCurve100
    };
  }, [locations, learningCurve100]);
  return _jsx(MultiskillLocationsContext.Provider, __assign({
    value: value
  }, {
    children: children
  }));
};